/* ============================================================================
   gs-cta-styling.js — grow-some
   Path: assets/gs-cta-styling.js

   Always-loaded helper for product pages. Linked from
   snippets/gs-cta-styling.liquid which renders unconditionally.

   Cached by browser between page loads. No Liquid vars — fully static,
   operates on any <product-info> element found in the DOM.

   What it does:
     - Wraps .product-form__quantity + <product-form> into a single .gs-cta-row
       flex container (used by the CSS for side-by-side qty + CTA layout on
       desktop). Runs on DOMContentLoaded.
   ============================================================================ */

(function(){
  'use strict';

  function wrapCtaRowFor(host){
    var qty = host.querySelector('.product-form__quantity');
    var form = host.querySelector('product-form');
    if (!qty || !form) return;
    if (qty.parentNode && qty.parentNode.classList.contains('gs-cta-row')) return;
    var wrap = document.createElement('div');
    wrap.className = 'gs-cta-row';
    qty.parentNode.insertBefore(wrap, qty);
    wrap.appendChild(qty);
    wrap.appendChild(form);
  }

  function wrapAll(){
    var hosts = document.querySelectorAll('product-info');
    for (var i = 0; i < hosts.length; i++) wrapCtaRowFor(hosts[i]);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', wrapAll);
  } else {
    wrapAll();
  }
})();